module.exports = __webpack_public_path__ + "img/ceviche.f8d1db90.jpg";